import { render, staticRenderFns } from "./PickerPoints.vue?vue&type=template&id=3942f2a4&lang=pug"
import script from "./PickerPoints.vue?vue&type=script&lang=js"
export * from "./PickerPoints.vue?vue&type=script&lang=js"
import style0 from "./PickerPoints.vue?vue&type=style&index=0&id=3942f2a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports